import type { ListingItem } from './types';

// An unparseable or missing date sinks to the end rather than throwing the
// whole listing out of order.
const UNDATED = 0;

const toTime = (publishedAt?: string): number => {
  if (!publishedAt) return UNDATED;
  const time = Date.parse(publishedAt);
  return Number.isNaN(time) ? UNDATED : time;
};

/**
 * Interleaves items from both CMSs newest first. A migrated piece keeps its
 * WordPress twin out of the list via `legacyHref`, and the same path never
 * appears twice however many groups mention it.
 */
export const mergeListingItems = (
  ...groups: (ListingItem[] | undefined)[]
): ListingItem[] => {
  const items = groups.flatMap((group) => group ?? []);
  const replacedPaths = new Set(
    items.flatMap((item) => (item.legacyHref ? [item.legacyHref] : []))
  );
  const byHref = new Map<string, ListingItem>();
  items.forEach((item) => {
    if (item.source === 'wordpress' && replacedPaths.has(item.href)) return;
    if (!byHref.has(item.href)) byHref.set(item.href, item);
  });
  return [...byHref.values()].sort(
    (a, b) => toTime(b.publishedAt) - toTime(a.publishedAt)
  );
};
